import { BaseController } from "./BaseController";
import ActiveCourse from "../types/ActiveCourse";

export class ActiveCourseController extends BaseController<ActiveCourse> {
  constructor() {
    super("activeCourses", "ActiveCoursesControllerDBCounters");
  }
}
